var exports = {
  "nM": "QuickReactionsRow.module__row___VWJMa2",
  "x6": "QuickReactionsRow.module__button___VWJMa2" + " " + __webpack_require__(77126)["AS"] + " " + __webpack_require__(77126)["QZ"],
  "g1": "QuickReactionsRow.module__emojiImg___VWJMa2",
};

module.exports = exports;
